module.exports = __webpack_public_path__ + "static/img/sign_have3.da924d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign_have3.png
// module id = XQ2y
// module chunks = 121